import './index.less';
import { useEffect, useState, useRef } from 'react';
import WarnPanel from './warn';
import DevicePanel from './device';
import ExplodedViewPanel from './exploded-view';


interface IProps {

}

export default function ScreenBottom(props: IProps) {


    return (
        <div className='screen-bottom-container'>
            <WarnPanel />
            <DevicePanel />
            <div className='divider'></div>
            <ExplodedViewPanel />
        </div>
    )
}